/* 「AI 進階功能」卡的顯示邏輯：狀態徽章、處理數量與能不能儲存。純函式，方便測試。 */
import type { AiService, AiServiceKind } from '@/types/assistant';

export type ServiceTone = 'success' | 'warn' | 'danger' | 'muted';

export function serviceStatus(svc: AiService): { tone: ServiceTone; label: string } {
  if (!svc.enabled) return { tone: 'muted', label: '未開啟' };
  if (svc.last_error) return { tone: 'danger', label: svc.paused ? '連線問題，稍後重試' : '連線問題' };
  if (!svc.ready) return { tone: 'warn', label: '設定不完整' };
  return { tone: 'success', label: '運作中' };
}

const n = (v: number | undefined) => v ?? 0;

/** 一行處理進度。沒有資料時回空字串，畫面就不顯示。 */
export function serviceStatsText(svc: AiService): string {
  const s = svc.stats ?? {};
  if (svc.kind === 'vision' || svc.kind === 'stt') {
    const unit = svc.kind === 'vision' ? '張' : '段';
    const verb = svc.kind === 'vision' ? '已描述' : '已轉成文字';
    const parts = [`${verb} ${n(s.done)} ${unit}`];
    if (n(s.failed)) parts.push(`失敗 ${n(s.failed)} ${unit}`);
    if (n(s.skipped)) parts.push(`略過 ${n(s.skipped)} ${unit}`);
    if (svc.enabled && n(s.pending)) parts.push(`待處理 ${n(s.pending)} ${unit}`);
    return n(s.done) + n(s.failed) + n(s.skipped) + n(s.pending) === 0 ? '' : parts.join('、');
  }
  if (svc.kind === 'embed') {
    if (!n(s.indexed) && !n(s.pending)) return '';
    return `已建立索引 ${n(s.indexed)} 筆` + (svc.enabled && n(s.pending) ? `、待處理 ${n(s.pending)} 筆` : '');
  }
  if (!n(s.samples_24h) && !n(s.open_alerts)) return '';
  return `過去 24 小時取樣 ${n(s.samples_24h)} 筆（${n(s.devices)} 台）` +
    (n(s.open_alerts) ? `、目前 ${n(s.open_alerts)} 件預警` : '');
}

export interface ServiceForm {
  enabled: boolean;
  base_url: string;
  model: string;
  language: string;
}

/** 開啟前一定要有的欄位；伺服器也會再檢查一次。 */
export function serviceMissing(kind: AiServiceKind, form: ServiceForm, chatConfigured: boolean): string {
  if (kind === 'trend') return '';
  if (kind === 'stt') return form.base_url.trim() ? '' : '要先填寫伺服器網址才能開啟。';
  if (form.base_url.trim()) return form.model.trim() || chatConfigured ? '' : '要先填寫模型名稱才能開啟。';
  return chatConfigured ? '' : '網址留空會沿用對話模型，但上方的模型連線還沒設定。';
}
